var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 0C13.6312 0 14.1 0.46875 14.1 1.03125V13C14.1 13.5625 13.6312 14 13.1 14H1.06875C0.5375 14 0.0999999 13.5625 0.0999999 13V1.03125C0.0999999 0.46875 0.5375 0 1.06875 0H13.1ZM4.31875 12V5.34375H2.25625V12H4.31875ZM3.2875 4.40625C3.94375 4.40625 4.475 3.875 4.475 3.21875C4.475 2.5625 3.94375 2 3.2875 2C2.6 2 2.06875 2.5625 2.06875 3.21875C2.06875 3.875 2.6 4.40625 3.2875 4.40625ZM12.1 12V8.34375C12.1 6.5625 11.6937 5.15625 9.6 5.15625C8.6 5.15625 7.9125 5.71875 7.63125 6.25H7.6V5.34375H5.63125V12H7.69375V8.71875C7.69375 7.84375 7.85 7 8.94375 7C10.0062 7 10.0062 8 10.0062 8.75V12H12.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.50a279539d66a20139615a5b09945b39.svg";
export { ForwardRef as ReactComponent };